import { CheckInReport } from "@/features/check-in-reports/check-in-report";
import { CHECK_IN_REPORT_QUERY } from "@/features/check-in-reports/graphql/check-in-report-query";

export const Route = createFileRoute({
  component: CheckInReport,
  loader: async ({ context, params }) => {
    if (context.urqlClient) {
      await context.urqlClient
        .query(CHECK_IN_REPORT_QUERY, {
          id: params.id,
        })
        .toPromise();
    }
  },
});
